import React, { useState, useEffect } from "react";
import { SimpleCard } from "@gull";
import { Formik, FieldArray } from "formik";
import { Helmet } from "react-helmet";
import { Modal, Row, Col, Button, Card } from "react-bootstrap";
import moment from "moment";
import Select from "react-select";
import { RenderTextInput } from "app/common/renderInput";
import {
  model,
  validationModel,
  tripTypeOptions,
  newValidationSchema,
} from "./Components/Add/charterFlightModel";
import { MdDelete } from "react-icons/md";
import swal from "sweetalert2";
import { addCharter } from "app/services/charterService";
import { NotificationManager } from "react-notifications";
import history from "@history.js";
import { dateValidation } from "app/services/timeDateService";
import FlightLegs from "./Components/Add/flightLegs/FlightLegs";
import FlightLegsReturn from "./Components/Add/flightLegsReturn/FlightLegs";
import LaddaButton, { ZOOM_OUT, CONTRACT_OVERLAY, ZOOM_IN } from "react-ladda";
import { useNavigate } from "react-router-dom";
import "./CreateFlight.css";

const AddCharter = () => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    model,
    validationModel,
    allFlightDates: [],
    showDateSelector: false,
    operationType: "",
    inputDates: "",
    fromDate: "",
    toDate: "",

    defaultDays: [
      { value: "0", label: "Sunday" },
      { value: "1", label: "Monday" },
      { value: "2", label: "Tuesday" },
      { value: "3", label: "Wednesday" },
      { value: "4", label: "Thursday" },
      { value: "5", label: "Friday" },
      { value: "6", label: "Saturday" },
    ],
    selectDaysValues: [],
    index: 0,
    tripType: {
      value: 1,
      label: "One Way",
    },
    valueState: [{ id: 0, label: "" }],
    departureValue: [{ id: 0, label: "" }],
    suggestions: [],
    depSuggestions: [],
    destinationValue: [{ id: 0, label: "" }],
    desSuggestion: [],
    timeDeparture: [{ time: "", timeString: "" }],
    timeArrival: [{ time: "", timeString: "" }],
    valueStateReturn: [{ id: 0, label: "" }],
    suggestionsReturn: [],
    departureValueReturn: [{ id: 0, label: "" }],
    depSuggestionsReturn: [],
    destinationValueReturn: [{ id: 0, label: "" }],
    desSuggestionReturn: [],
    timeDepartureReturn: [{ time: "", timeString: "" }],
    timeArrivalReturn: [{ time: "", timeString: "" }],
    airlineDetails: [{ id: 0, label: "" }],
    airportDetails: [{ id: 0, label: "" }],
  });

  useEffect(() => {
    // Your initialization code here (if any)
  }, []);

  const changeTripType = (type) => {
    setState({ ...state, tripType: type });
    const { model } = state;
    if (type.value === 2) {
      const newModel = {
        ...model,
        flightLegs: {
          ...model.flightLegs,
          return: [
            {
              flightNumber: "",
              airportDepartureId: "",
              airportDestinationId: "",
              flightCarrierId: "",
              checkInBaggage: "",
              fareType: "",
              arrivalTime: "",
              departureTime: "",
            },
          ],
        },
      };
      setState({ ...state, returnStarted: type.value, model: newModel });
    } else {
      setState({ ...state, model });
    }
  };

  const showDateHandler = () => {
    setState({ ...state, showDateSelector: true });
  };

  const handleClose = () => {
    setState({ ...state, showDateSelector: false });
  };

  const weeklyDatesSubmit = (date1, date2, days) => {
    let start = new Date(date1);
    const finish = new Date(date2);
    const dayMilliSeconds = 1000 * 60 * 60 * 24;
    const dates = [];
    while (start.getTime() <= finish.getTime()) {
      const day = start.getDay();

      days.map((d) => {
        if (d === day) {
          if (dateValidation(moment(start).format("MM/DD/YYYY"))) {
            dates.push(moment(start).format("YYYY-MM-DD"));
          }
        }
      });
      start = new Date(+start + dayMilliSeconds);
    }
    if (dates.length !== 0) {
      // setState(
      //   produce((draft) => {
      //     draft.allFlightDates [...dates]
      //   })
      // );
      setState({ ...state, allFlightDates: [...dates] });
      setTimeout(() => {
        document.getElementsByClassName("close")[0].click();
      }, 10);
      // state.operationType = "";
      // state.fromDate = "";
      // state.toDate = "";
      console.log(state);
    }
  };

  const datesSubmit = () => {
    const { inputDates } = state;
    if (inputDates.length !== 0) {
      const dates = inputDates.split("\n");
      const newDates = [];
      dates.map((date) => {
        if (dateValidation(moment(date).format("MM/DD/YYYY"))) {
          date.length !== 0 &&
            moment(date).format("YYYY-MM-DD") !== "Invalid date" &&
            newDates.push(moment(date).format("YYYY-MM-DD"));
        }
      });
      setState({ ...state, allFlightDates: [...newDates] });
      setTimeout(() => {
        document.getElementsById("close")[0].click();
      }, 10);
      // state.operationType = "";
      // state.fromDate = "";
      // state.toDate = "";
    } else {
      NotificationManager.error("Please select dates");
    }
  };

  const handleDeleteContact = (date) => {
    const { allFlightDates } = state;
    const newDates = [...allFlightDates];
    const index = newDates.indexOf(date);
    if (index > -1) {
      newDates.splice(index, 1);
    }
    setState({ ...state, allFlightDates: [...newDates] });
  };

  const changeCarrierValues = () => {
    const values = [...state.valueState];
    values.push({ id: 0, label: "" });
    setState({ ...state, valueState: values });
  };

  const changeDepartureValues = () => {
    const values = [...state.departureValue];
    values.push({ id: 0, label: "" });
    setState({ ...state, departureValue: values });
  };

  const changeDestinationValues = () => {
    const values = [...state.destinationValue];
    values.push({ id: 0, label: "" });
    setState({ ...state, destinationValue: values });
  };

  const changeTimeDepartureValues = () => {
    const values = [...state.timeDeparture];
    values.push({ time: "", timeString: "" });
    setState({ ...state, timeDeparture: values });
  };

  const changeTimeDepartureInput = (time, timeString, index) => {
    const newTimeDepValue = { time, timeString };
    let newValue = [...state.timeDeparture];
    newValue[index] = newTimeDepValue;
    setState({ ...state, index });
    setState({ ...state, timeDeparture: newValue });
  };

  const changeTimeArrivalValues = () => {
    const values = [...state.timeArrival];
    values.push({ time: "", timeString: "" });
    setState({ ...state, timeArrival: values });
  };

  const changeTimeArrivalInput = (time, timeString, index) => {
    const newTimeArrivalValue = { time, timeString };
    let newValue = [...state.timeArrival];
    newValue[index] = newTimeArrivalValue;
    setState({ ...state, index });
    setState({ ...state, timeArrival: newValue });
  };

  // Rest of the functions...

  const changeCarrierValuesReturn = () => {
    const values = [...state.valueStateReturn];
    values.push({ id: 0, label: "" });
    setState({ ...state, valueStateReturn: values });
  };

  const changeDepartureValuesReturn = () => {
    const values = [...state.departureValueReturn];
    values.push({ id: 0, label: "" });
    setState({ ...state, departureValueReturn: values });
  };

  // for destination
  const changeDestinationValuesReturn = () => {
    const values = [...state.destinationValueReturn];
    values.push({ id: 0, label: "" });
    setState({ ...state, destinationValueReturn: values });
  };

  // time
  const changeTimeDepartureValuesReturn = () => {
    const values = [...state.timeDepartureReturn];
    values.push({ time: "", timeString: "" });
    setState({ ...state, timeDepartureReturn: values });
  };

  const changeTimeDepartureInputReturn = (time, timeString, index) => {
    const newTimeDepValue = { time, timeString };
    let newValue = [...state.timeDepartureReturn];
    newValue[index] = newTimeDepValue;
    setState({ ...state, index });
    setState({ ...state, timeDepartureReturn: newValue });
  };

  const changeTimeArrivalValuesReturn = () => {
    const values = [...state.timeArrivalReturn];
    values.push({ time: "", timeString: "" });
    setState({ ...state, timeArrivalReturn: values });
  };

  const changeTimeArrivalInputReturn = (time, timeString, index) => {
    const newTimeArrivalValue = { time, timeString };
    let newValue = [...state.timeArrivalReturn];
    newValue[index] = newTimeArrivalValue;
    setState({ ...state, index });
    setState({ ...state, timeArrivalReturn: newValue });
  };

  const submitForm = async (values) => {
    try {
      const { tripType, allFlightDates } = state;

      if (allFlightDates.length !== 0) {
        // TODO: for onword and return functionality
        const legs = { onward: [], return: [] };

        if (values.flightLegs.onward) {
          values.flightLegs.onward.map((value, index) => {
            legs.onward.push({
              ...value,
            });
          });
        }
        if (values.flightLegs.return) {
          values.flightLegs.return.map((value, index) => {
            legs.return.push({
              ...value,
            });
          });
        }

        //TODO: for one way
        const flightLegs = [];
        values.flightLegs.onward.map((flightLeg, index) => {
          flightLegs.push({
            ...flightLeg,
          });
        });

        const sendData = {
          ...values,
          tripType: tripType.label,
          tripTypeId: tripType.value,
          flightDates: allFlightDates,
          flightLegs: flightLegs,
        };
        var result = await addCharter(sendData);
        if (result.status == "Success") {
          NotificationManager.success(result.message, "Created!", 5000);
          navigate("/admin/flight/list");
          // history.push({
          //   pathname: "/admin/flight/list",
          // });
        } else {
          NotificationManager.error(
            "Something went wrong please try again after sometime."
          );
        }
      } else {
        NotificationManager.error("Please enter all details!");
      }
    } catch (error) {
      NotificationManager.error("Please enter all details!");
    }
  };
  return (
    <div>
      <Helmet>
        <title>Create Charter</title>
      </Helmet>
      <Formik
        onSubmit={submitForm}
        initialValues={model}
        validationSchema={
          state?.tripType?.value == 2 ? newValidationSchema : validationModel
        }
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          isValid,
          dirty,
          setFieldValue,
        }) => {
          return (
            <form
              className="needs-validation"
              onSubmit={handleSubmit}
              noValidate
            >
              {/* {JSON.stringify(values)} */}
              {/* {Object.values(errors).map(msg => (
                      <>
                        {msg}
                        <br />
                      </>
                    ))} */}
              <div className="row">
                <div className="col-12 ">
                  <SimpleCard title="Create Flights" className="mb-4">
                    <div className="form-row">
                      <Select
                        name="tripType"
                        classNamePrefix="react-select"
                        options={tripTypeOptions}
                        value={state.tripType}
                        onChange={(type) => changeTripType(type)}
                        placeholder="Select trip type"
                      />
                    </div>
                  </SimpleCard>
                </div>
              </div>

              <div className="row">
                <Col md={state.tripType.value == 2 ? "6" : "12"}>
                  <Card className="p-4 mb-4 border">
                    <Card.Title className="mb-3 titleMain">
                      Flight Data Onward
                    </Card.Title>

                    <FieldArray
                      name="flightLegs.onward"
                      render={(arrayHelpers) => (
                        <>
                          {values.flightLegs.onward &&
                          Object.keys(values.flightLegs.onward).length > 0
                            ? values.flightLegs.onward.map((leg, index) => (
                                <div key={index} className="">
                                  <FlightLegs
                                    index={index}
                                    arrayHelpers={arrayHelpers}
                                    values={values}
                                    touched={touched}
                                    errors={errors}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    changeTimeDepartureInput={
                                      changeTimeDepartureInput
                                    }
                                    timeDeparture={state.timeDeparture}
                                    timeArrival={state.timeArrival}
                                    changeTimeArrivalInput={
                                      changeTimeArrivalInput
                                    }
                                    tripType={state.tripType.value}
                                    setFieldValue={setFieldValue}
                                  />
                                </div>
                              ))
                            : ""}
                          <Row className="px-4">
                            <Col
                              lg={state.tripType.value == 2 ? "9" : "11"}
                            ></Col>
                            <Col sm="6" lg={state.tripType.value ? "3" : "1"}>
                              <Button
                                className="mb-4 d-none"
                                variant="primary"
                                type="button"
                                onClick={() => {
                                  arrayHelpers.push({
                                    flightNumber: "",
                                    airportDepartureId: 0,
                                    airportDestinationId: 0,
                                    flightCarrierId: 0,
                                    checkInBaggage: "",
                                    fareType: "",
                                    arrivalTime: "",
                                    departureTime: "",
                                  });
                                  changeCarrierValues();
                                  changeDepartureValues();
                                  changeDestinationValues();
                                  changeTimeDepartureValues();
                                  changeTimeArrivalValues();
                                }}
                              >
                                Add Leg
                              </Button>
                            </Col>
                          </Row>
                        </>
                      )}
                    />
                  </Card>
                </Col>
                {state.tripType.value == 2 && (
                  <Col md="6">
                    <Card className="p-4 mb-4">
                      <Card.Title className="mb-3 titleMain">
                        Flight Data Return
                      </Card.Title>

                      <FieldArray
                        name="flightLegs.return"
                        render={(arrayHelpers) => (
                          <>
                            {values.flightLegs.return &&
                            Object.keys(values.flightLegs.return).length > 0
                              ? values.flightLegs.return.map((leg, index) => (
                                  <div key={index}>
                                    <FlightLegsReturn
                                      index={index}
                                      values={values}
                                      touched={touched}
                                      errors={errors}
                                      handleChange={handleChange}
                                      handleBlur={handleBlur}
                                      arrayHelpers={arrayHelpers}
                                      valueState={state.valueStateReturn}
                                      timeDeparture={state.timeDepartureReturn}
                                      changeTimeDepartureInput={
                                        changeTimeDepartureInputReturn
                                      }
                                      timeArrival={state.timeArrivalReturn}
                                      changeTimeArrivalInput={
                                        changeTimeArrivalInputReturn
                                      }
                                      tripType={state.tripType.value}
                                    />
                                  </div>
                                ))
                              : ""}
                            <Row className="px-4">
                              <Col lg="9"></Col>
                              <Col sm="6" lg="3">
                                <Button
                                  className="mb-4  d-none"
                                  variant="primary"
                                  type="button"
                                  onClick={() => {
                                    arrayHelpers.push({
                                      flightNumber: "",
                                      airportDepartureId: 0,
                                      airportDestinationId: 0,
                                      flightCarrierId: 0,
                                      checkInBaggage: "",
                                      fareType: "",
                                      arrivalTime: "",
                                      departureTime: "",
                                    });
                                    changeCarrierValuesReturn();
                                    changeDepartureValuesReturn();
                                    changeDestinationValuesReturn();
                                    changeTimeDepartureValuesReturn();
                                    changeTimeArrivalValuesReturn();
                                  }}
                                >
                                  Add Leg
                                </Button>
                              </Col>
                            </Row>
                          </>
                        )}
                      />
                    </Card>
                  </Col>
                )}
              </div>

              <div className="row">
                <div className="col-md-6 col-12">
                  <SimpleCard title="Seat Booking and Pricing" className="mb-2">
                    <hr />

                    <Row className="form-row">
                      <Col xs={12} lg={6} className="mt-1">
                        <RenderTextInput
                          type="number"
                          name="seats"
                          display="Seats"
                          value={values.seats}
                          error={errors.seats}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.seats}
                          required
                        ></RenderTextInput>
                      </Col>
                      <Col xs={12} lg={6}>
                        <div className="d-flex">
                          <p className="me-2">Do You have live PNR? </p>
                          <div className="form-check me-2">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isPnrRequired"
                              id="pnrYes"
                              value={values.isPnrRequired}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setFieldValue(`isPnrRequired`, true);
                              }}
                            />
                            <label
                              className="form-check-label mr-3"
                              htmlFor="pnrYes"
                            >
                              Yes
                            </label>
                          </div>
                          <div className="form-check ">
                            <input
                              className="form-check-input "
                              type="radio"
                              name="isPnrRequired"
                              id="pnrNo"
                              value={values.isPnrRequired}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setFieldValue(`isPnrRequired`, false);
                              }}
                            />
                            <label className="form-check-label" htmlFor="pnrNo">
                              No
                            </label>
                          </div>
                          <span className="text-danger">*</span>
                        </div>
                        {values.isPnrRequired === true ? (
                          <RenderTextInput
                            type="text"
                            name="pnr"
                            value={values.pnr}
                            error={errors.pnr}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.pnr}
                            style={{
                              marginTop: "-13%",
                              // marginLeft: "-14px",
                              // width: "114%",
                            }}
                          ></RenderTextInput>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <h5>Per Seat(Adult)</h5>
                    <Row className="form-row">
                      <RenderTextInput
                        type="number"
                        display="Base Fare"
                        name="adultBaseFare"
                        value={values.adultBaseFare}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.adultBaseFare}
                        touched={touched.adultBaseFare}
                        required
                      ></RenderTextInput>
                      <RenderTextInput
                        type="number"
                        display="YQ"
                        name="adultYQ"
                        value={values.adultYQ}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.adultYQ}
                        touched={touched.adultYQ}
                        required
                      ></RenderTextInput>
                      <RenderTextInput
                        type="number"
                        display="Total Tax"
                        name="adultTotalTaxPerSeat"
                        value={values.adultTotalTaxPerSeat}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.adultTotalTaxPerSeat}
                        touched={touched.adultTotalTaxPerSeat}
                        required
                      ></RenderTextInput>
                    </Row>

                    <h5>Per Seat(Child)</h5>
                    <Row className="form-row">
                      <RenderTextInput
                        type="number"
                        display="Base Fare"
                        name="childBaseFare"
                        value={values.childBaseFare}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.childBaseFare}
                        touched={touched.childBaseFare}
                        required
                      ></RenderTextInput>
                      <RenderTextInput
                        type="number"
                        display="YQ"
                        name="childYQ"
                        value={values.childYQ}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.childYQ}
                        touched={touched.childYQ}
                        required
                      ></RenderTextInput>
                      <RenderTextInput
                        type="number"
                        display="Total Tax"
                        name="childTotalTaxPerSeat"
                        value={values.childTotalTaxPerSeat}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.childTotalTaxPerSeat}
                        touched={touched.childTotalTaxPerSeat}
                        required
                      ></RenderTextInput>
                    </Row>
                    <h5> Per Seat(Infant)</h5>
                    <Row className="form-row">
                      <RenderTextInput
                        type="number"
                        display="Base Fare"
                        name="infrantBaseFare"
                        value={values.infrantBaseFare}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.infrantBaseFare}
                        touched={touched.infrantBaseFare}
                        required
                      ></RenderTextInput>
                      <RenderTextInput
                        type="number"
                        display="YQ"
                        name="infrantYQ"
                        value={values.infrantYQ}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.infrantYQ}
                        touched={touched.infrantYQ}
                        required
                      ></RenderTextInput>
                      <RenderTextInput
                        type="number"
                        display="Total Tax"
                        name="infrantTotalTaxPerSeat"
                        value={values.infrantTotalTaxPerSeat}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.infrantTotalTaxPerSeat}
                        touched={touched.infrantTotalTaxPerSeat}
                        required
                      ></RenderTextInput>
                    </Row>
                    <Row className="form-row">
                      <label htmlFor="refundable">Refundable</label>
                      <div className="custom-control custom-switch">
                        <input
                          name="refundable"
                          value={values.refundable}
                          error={errors.refundable}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="checkbox"
                          className="custom-control-input"
                          id="refundable"
                          required
                        />
                        <label
                          className="custom-control-label ml-4"
                          htmlFor="refundable"
                        ></label>
                      </div>
                    </Row>
                  </SimpleCard>
                </div>
                <div className="col-md-6 col-12 ">
                  <div className="row">
                    <div className="col-12">
                      <SimpleCard className="mb-2">
                        <h5>
                          Flight Dates
                          <span className="text-danger"> *</span>
                        </h5>

                        <button
                          className="btn btn-primary mb-4"
                          onClick={showDateHandler}
                          type="button"
                        >
                          Select Flight Dates
                        </button>

                        {state.allFlightDates.length !== 0 && (
                          <div className="table-wrapper-scroll-y my-custom-scrollbar">
                            <table
                              className="table table-sm table-hover table-bordered"
                              style={{
                                maxHeight: "10rem",
                              }}
                            >
                              <thead>
                                <tr>
                                  <th scope="col">Date</th>
                                  <th scope="col">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {state.allFlightDates.map((date, key) => {
                                  return (
                                    <tr key={key}>
                                      <td> {date} </td>
                                      <td>
                                        <div className="cursor-pointer">
                                          <MdDelete
                                            className="text-danger"
                                            size={18}
                                            onClick={() => {
                                              swal
                                                .fire({
                                                  title: "Are you sure?",
                                                  text: "You won't be able to revert this",
                                                  icon: "warning",
                                                  type: "question",
                                                  showCancelButton: true,
                                                  confirmButtonColor: "#3085d6",
                                                  cancelButtonColor: "#d33",
                                                  confirmButtonText:
                                                    "Yes, delete it!",
                                                  cancelButtonText: "No",
                                                })
                                                .then((result) => {
                                                  if (result.value) {
                                                    handleDeleteContact(date);
                                                  } else {
                                                    swal.fire({
                                                      title: "Cancelled!",
                                                      text: "Permission denied.",
                                                      type: "error",
                                                      icon: "error",
                                                      timer: 1500,
                                                    });
                                                  }
                                                });
                                            }}
                                          ></MdDelete>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        )}
                        <br />
                        <small className="text-danger">
                          {touched.flightDates &&
                            state.allFlightDates.length === 0 &&
                            "Flight dates are required"}
                        </small>
                      </SimpleCard>

                      <Modal
                        show={state.showDateSelector}
                        backdropClassName={false}
                        backdrop="static"
                        keyboard={false}
                        onHide={handleClose}
                        centered
                      >
                        <Modal.Header>
                          <h4 className="text-primary ">Select Flight Dates</h4>
                          {/* <button
                            onClick={handleClose}
                            type="button"
                            className="close btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button> */}
                          <button
                            type="button"
                            onClick={handleClose}
                            className="close btn btn"
                            data-dismiss="modal"
                          >
                            <div style={{ fontSize: "15px" }}>X</div>
                          </button>
                        </Modal.Header>
                        <div className="modal-body">
                          <div className="row mb-2">
                            <div className="col-5">
                              <h5 className="ml-4"> Operation Type</h5>
                            </div>

                            <div className="col-7 mt-1">
                              <input
                                type="radio"
                                className="me-1"
                                value="dates"
                                onChange={(e) =>
                                  setState({
                                    ...state,
                                    operationType: e.target.value,
                                  })
                                }
                                name="operationType"
                                id="dates"
                              />
                              <label htmlFor="dates" className="me-4">
                                Dates
                              </label>

                              <input
                                type="radio"
                                className="me-1"
                                value="weeklyTurn"
                                onChange={(e) =>
                                  setState({
                                    ...state,
                                    operationType: e.target.value,
                                  })
                                }
                                name="operationType"
                                id="weeklyTurn"
                              />
                              <label htmlFor="weeklyTurn">Weekly Turn</label>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              {state.operationType === "dates" && (
                                <>
                                  <label htmlFor="inputDates mt-4">
                                    Flight Dates
                                    <span className="text-danger"> *</span>
                                    <br />
                                    <span>
                                      <p>
                                        Separate dates with line formatting.
                                        E.g. (YYYY-MM-DD)
                                        <br />
                                        2021-12-24
                                        <br />
                                        2022-01-05
                                      </p>
                                    </span>
                                  </label>

                                  <textarea
                                    className=" form-control"
                                    style={{ resize: "none" }}
                                    name="inputDates"
                                    id="inputDates"
                                    value={state.inputDates}
                                    onChange={(e) => {
                                      setState({
                                        ...state,
                                        inputDates: e.target.value,
                                      });
                                    }}
                                    cols="40"
                                    rows="5"
                                    required
                                  ></textarea>
                                </>
                              )}

                              {state.operationType === "weeklyTurn" && (
                                <>
                                  <Select
                                    name="defaultDays"
                                    options={state.defaultDays}
                                    isMulti
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    onChange={(values) => {
                                      const daysValues = [];
                                      values.map(({ value }) => {
                                        daysValues.push(value * 1);
                                      });
                                      daysValues.length !== 0 &&
                                        setState({
                                          ...state,
                                          selectDaysValues: [...daysValues],
                                        });
                                    }}
                                  />
                                  <label htmlFor="fromDate" className="mt-2">
                                    Date From
                                  </label>
                                  <input
                                    id="fromDate"
                                    type="date"
                                    min={moment().format("YYYY-MM-DD")}
                                    onChange={(e) => {
                                      setState({
                                        ...state,
                                        fromDate: e.target.value,
                                      });
                                    }}
                                    value={state.fromDate}
                                    name="fromDate"
                                    className="form-control"
                                  />

                                  <label htmlFor="toDate" className="mt-2">
                                    To
                                  </label>
                                  <input
                                    id="toDate"
                                    type="date"
                                    min={moment(state.fromDate).format(
                                      "YYYY-MM-DD"
                                    )}
                                    onChange={(e) =>
                                      setState({
                                        ...state,
                                        toDate: e.target.value,
                                      })
                                    }
                                    value={state.toDate}
                                    name="toDate"
                                    className="form-control"
                                  />
                                </>
                              )}

                              {state.operationType.length !== 0 && (
                                <>
                                  <Row>
                                    <Col lg={6} xs={6}>
                                      <button
                                        className="btn btn-primary mt-3 float-end"
                                        onClick={() => {
                                          state.operationType === "dates"
                                            ? datesSubmit()
                                            : weeklyDatesSubmit(
                                                state.fromDate,
                                                state.toDate,
                                                state.selectDaysValues
                                              );
                                        }}
                                      >
                                        Submit
                                      </button>
                                    </Col>
                                    <Col lg={6} xs={6}>
                                      <Button
                                        onClick={handleClose}
                                        className="mt-3"
                                        variant="outline-primary"
                                      >
                                        Cancel
                                      </Button>
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-12">
                      <SimpleCard title="Send Confirmation" className="mb-4">
                        <Row className="form-row">
                          <RenderTextInput
                            type="email"
                            name="commEmailOne"
                            display="Person-1"
                            placeholder="Email 1"
                            value={values.commEmailOne}
                            error={errors.commEmailOne}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.commEmailOne}
                          ></RenderTextInput>

                          <RenderTextInput
                            type="email"
                            name="commEmailTwo"
                            display="Person-2"
                            placeholder="Email 2"
                            value={values.commEmailTwo}
                            error={errors.commEmailTwo}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.commEmailTwo}
                          ></RenderTextInput>
                        </Row>
                      </SimpleCard>
                    </div>
                  </div>
                </div>
              </div>
              <LaddaButton
                loading={isSubmitting}
                data-style={ZOOM_IN}
                className="btn btn-primary mb-3"
                type="submit"
              >
                Create Booking
              </LaddaButton>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default AddCharter;
